import { useContext } from "react";
import { LoaderCard, LoaderInner } from "../../../common/Loader";
import { PATH_REGION } from "../../../../helper/mapPath";
import LangContext from "../../../../contexts/LangContext";
import { translate, translateNumber } from "../../../../helper";
import "./index.css";

const MapChart = (props) => {
  const { lang } = useContext(LangContext);
  const { pid, did, rid } = props;

  const handleMouseOver = (el) => {
    // let opacity = 0.8;
    // document.querySelectorAll(".sh-district-region").forEach((region, j) => {
    //   if (j % 3 === 1) {
    //     opacity = 0.8;
    //   } else if (j % 3 === 2) {
    //     opacity = 0.7;
    //   } else {
    //     opacity = 0.6;
    //   }
    //   region.querySelectorAll("path").forEach((path) => {
    //     path.style.opacity = opacity;
    //   });
    // });
    // const myClass = Array.from(el.target.classList).find((c) => c.startsWith("region-"));
    // document.querySelectorAll("." + myClass).forEach((path) => {
    //   path.style.opacity = 1;
    // });
    document.querySelector(".sh-region-map-legend").innerHTML = el.target.getAttribute("datarname");
  };

  const handleMouseLeave = (el) => {
    // let opacity = 0.8;
    // document.querySelectorAll(".sh-district-region").forEach((region, j) => {
    //   if (j % 3 === 1) {
    //     opacity = 0.8;
    //   } else if (j % 3 === 2) {
    //     opacity = 0.7;
    //   } else {
    //     opacity = 0.6;
    //   }
    //   region.querySelectorAll("path").forEach((path) => {
    //     path.style.opacity = opacity;
    //   });
    // });
  };

  const districtPath = PATH_REGION.find((p) => p.id.split("-")[1] === pid).districts.find((d) => d.id === did);
  let opacity = 0.8;

  return (
    <section className="sh-region-map-chart">
      <div className="container">
        <div className="container-fluid card sh-card-map">
          <div className="sh-region-map-legend"></div>
          {!props.fetched && <LoaderCard />}
          <h3 className="text-center pt-2">{props.district["name_" + lang] + " " + translateNumber(rid, lang)} </h3>
          <div className="row">
            <div className="col-md-6">
              <div className="sh-map-region">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2550 1500" enableBackground="new 0 0 2550 1500" xmlSpace="preserve">
                  <defs>
                    <pattern id="pattern-national-park" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(45)">
                      <line x1="0" y="0" x2="0" y2="6" stroke="#194d33" strokeWidth="10" />
                    </pattern>
                  </defs>
                  <g id={districtPath.id} transform={districtPath.districtTransform} style={{ scale: 3 }}>
                    {districtPath.regions.map((r, j) => {
                      opacity = opacity - 0.15;

                      return (
                        <g className="sh-district-region" key={j}>
                          {r.subregions.map((sr, k) => {
                            const style = { ...sr.style };

                            // if (props.tab === "federal") {
                            //   style.strokeWidth = 0;
                            //   // style.strokeOpacity = 0.1;
                            // }

                            // National Park data
                            if (sr.data) {
                              opacity = 1;
                            }
                            let fillColor = props.provinceColor;

                            if (r.id !== parseInt(rid)) {
                              opacity = 1;
                              fillColor = "#00000015";
                            }

                            const strokeColor = style && style.strokeWidth ? fillColor : "#FFFFFF";

                            return (
                              <g key={k}>
                                <path
                                  id={"region-" + districtPath.id + "-" + sr.id}
                                  style={style}
                                  className={"district-" + districtPath.id + " region-" + districtPath.id + "-" + parseFloat(sr.id).toFixed(0)}
                                  stroke={strokeColor}
                                  fill={sr.data && sr.data.key === "NP" ? "url(#pattern-national-park)" : fillColor}
                                  d={sr.d}
                                  opacity={opacity}
                                  dataspecial={sr.data ? sr.data["value_" + lang] : ""}
                                  datapid={pid}
                                  datadid={districtPath.id}
                                  datarid={parseFloat(sr.id).toFixed(0)}
                                  datarname={props.district["name_" + lang] + ": " + translateNumber(sr.id, lang)}
                                  onMouseOver={!sr.data && sr.id ? handleMouseOver : () => {}}
                                  onMouseLeave={handleMouseLeave}
                                ></path>
                              </g>
                            );
                          })}
                        </g>
                      );
                    })}
                  </g>
                </svg>
              </div>
            </div>
            <div className="col-md-6">
              <table className="table table-bordered sh-table-party mt-5">
                <thead>
                  <tr>
                    <th></th>
                    {props.region.map((r, i) => (
                      <th key={i} className="sh-left">
                        {translate("region", lang) + " " + r["name_" + lang]}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {!props.fetched ? (
                    <tr>
                      <td colSpan={3}>
                        <LoaderInner />
                      </td>
                    </tr>
                  ) : (
                    <>
                      <tr>
                        <td className="sh-bold">{translate("total_voter", lang)}</td>
                        {props.region.map((r, i) => (
                          <td key={i} className="">
                            {translateNumber(r.total_voter, lang)}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="sh-bold">{translate("area", lang)}</td>
                        {props.region.map((r, i) => (
                          <td className="" key={i}>
                            {translateNumber(r.area_sq_km.toFixed(2), lang)} {translate("sq_km", lang)}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="sh-bold">{translate("voting_booth", lang)}</td>
                        {props.region.map((r, i) => (
                          <td className="" key={i}>
                            {translateNumber(r.voting_booth, lang)}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="sh-bold">{translate("election_expense_limit", lang)}</td>
                        {props.region.map((r, i) => (
                          <td className="" key={i}>
                            {translate("nrs", lang)} {translateNumber(r.election_expense_limit, lang)}
                          </td>
                        ))}
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapChart;
